<script setup lang="ts">
import { getGlyph } from "@overlay/assets";
import { isReferralCodeValid, signupData } from "../data";
import useStepEmits from "./useStepEmits";
import CodeInput from "../../CodeInput.vue";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";

defineEmits(["stepComplete", "stepLoading"]);
const { t } = useI18n();
const { emitStepCompleted } = useStepEmits();
const isCodeError = ref(null);
const codeLabelClass = computed(() => {
  if (isCodeError.value === null) {
    return "invisible";
  } else if (isCodeError.value) {
    return "color-text--bright-red-100";
  }
  return "color-text--green-150";
});
const codeLabel = computed(() => {
  if (isCodeError.value === false) {
    return t("pages.signup.code.correct");
  }
  return t("pages.signup.code.incorrect");
});
async function handleCodeInput(code: string) {
  if (code.length !== 6) {
    isCodeError.value = null;
    return;
  }
  isCodeError.value = !(await isReferralCodeValid(code));
  if (isCodeError.value) {
    emitStepCompleted(false);
  } else {
    signupData.referralCode = code;
    emitStepCompleted(true);
  }
}
// onBeforeMount(async () => {
//   if (signupData.referralCode) {
//     await handleCodeInput(signupData.referralCode);
//   }
// });
</script>
<template>
  <label v-depixel for="referralCode"
    >{{ $t("pages.signup.step-names.SignupReferralStep") }}
  </label>
  <span v-depixel-normal class="font--s text-center" :class="codeLabelClass">
    {{ codeLabel }}
  </span>
  <code-input
    :field-height="48"
    :field-width="48"
    :fields="6"
    :required="true"
    class="code-input font depixel normal"
    type="text"
    @change="handleCodeInput"
    @paste="handleCodeInput"
  />
  <span v-depixel-normal for="referralCode">
    {{ $t("pages.signup.referral.no-code") }}
  </span>
  <div v-depixel class="socials flex center">
    <a href="https://t.me/bithotelcommunity" target="_blank">
      <img :src="getGlyph('telegram')" alt="Telegram logo" />
      {{ $t("global.join").toLocaleUpperCase() }} 30K+
      {{ $t("global.members").toLocaleUpperCase() }}
    </a>
    <a href="https://discord.gg/RFFZNwxY9n" target="_blank">
      <img :src="getGlyph('discord')" alt="Discord logo" />
      {{ $t("global.join").toLocaleUpperCase() }} 45K+
      {{ $t("global.members").toLocaleUpperCase() }}
    </a>
  </div>
</template>
<style scoped lang="scss">
.code-input:deep() {
  input {
    text-transform: uppercase;
  }
}
.invisible {
  opacity: 0;
}
.socials {
  gap: get-size(s);
  font-size: 10px;

  a {
    text-decoration: none;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: get-size(xs);
    padding: get-size(xs);
    // background: get-color(blue-300);
    display: flex;
    transition: scale 300ms ease;
    border-radius: get-size(xs);
    color: #fff;

    &[href*="t.me"] {
      background: #0088cc;
    }

    &[href*="discord"] {
      background-color: #5865f2;
    }

    img {
      max-width: 32px;
      transition: scale 300ms ease;
    }

    &:hover {
      scale: 1.1;

      img {
        scale: 1.1;
      }
    }
  }
}
</style>
